<app-card-list [items]="projects()" [trackByFn]="trackByProjectId">
  <ng-template #cardTemplate let-project>
    <app-project-card
      (archiveProjectEvent)="onArchive($event)"
      (deleteProjectEvent)="onDelete($event)"
      (copyProjectEvent)="onCopy($event)"
      (editProjectEvent)="onEdit($event)"
      (goToProjectEvent)="goToProject(project.id)"
      (invitationResponseEvent)="onInvitationResponse($event.projectId, $event.accept)"
      [chaptersCompleted]="project.progress.first"
      [project]="project"
      [totalChapters]="project.progress.second"
      [projectUserDetail]="projectUserDetails().get(project.id)"
    ></app-project-card>
  </ng-template>
</app-card-list>
